import { NavLink } from "react-router-dom"
import info from "../../data/info"
import { logMessage } from "../../utils/utils"

const scrollUp = () => {
  window.scrollTo({ top: 0, behavior: "smooth" })
}

const handleClick = () => {
  scrollUp()
  logMessage("Замовити дзвінок")
}

const PhoneButton = ({ children }) => {
  return (
    <a
      href={info.tel.number}
      className=" lg:hover:text-[#668efcef] lg:hover:underline underline-offset-2 lg:hover:scale-105 lg:hover:cursor-pointer duration-200"
    >
      <button
        className="hover:scale-105 duration-300"
        onClick={() => logMessage("Замовити дзвінок")}
      >
        <div
          className={`text-2xl sm:text-3xl md:text-4xl ${
            children ? "font-semibold" : "font-bold"
          }  tracking-[.10em] px-3 py-2 rounded-md text-white bg-[#002998ef]`}
        >
          099 33 56 296
        </div>
      </button>
    </a>
  )
}

export default PhoneButton
